// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2iNSx","label":"CategoryService_label__2BJxi","location":"CategoryService_location__OgKm1"};